import React, { FunctionComponent } from "react";
import styles from "./styles.module.scss";
import { Stack } from "@mui/material";
import { ShelvingTheme } from "../../../hooks/shelvings";
import { ShelvingUtilities } from "../../../models/ShelvingUtilities";

export const ShelvingThemeChip: FunctionComponent<IShelvingThemeChipProps> = ({ theme }) => {
  return (
    <Stack direction={"row"} alignItems={"center"} spacing={1}>
      <div
        className={styles.imageDiv}
        style={{ backgroundImage: `url(${ShelvingUtilities.getThemeImage(theme)})` }}
      />
      <p>{ShelvingUtilities.getThemeString(theme)}</p>
    </Stack>
  );
};

interface IShelvingThemeChipProps {
  theme: ShelvingTheme;
}
